import React, { Component, PropTypes as pt } from 'react';
import Switch from 'react-bootstrap-switch';

class Checkbox extends Component {
    constructor (props) {
        super(props);

        this.state = {
            value: props.value,
            edited: false
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentWillReceiveProps (nextProps) {
        if (this.state.edited) {
            this.setState({
                edited: false,
                value: nextProps.value
            });
        }
    }

    handleChange (ev, value) {
        if (this.props.preferenceName === 'images' && this.props.otherPreferences.listOrGrid === 'table') {
            // cannot show thumbnails for: table layout 
            this.props.storeEdits(false)
            this.setState({
                value: false,
                edited: true
            })
        } else {
            this.setState({
                value: value,
                edited: true
            });
            // Stores the edits for later reference
            this.props.storeEdits(value);
        }
    }

    render () {
        // console.log('checkbox', this.props);
        
        const value = (this.state.edited) ?
            this.state.value :
            this.props.value
            
        if (this.props.preferenceName === 'images' && this.props.otherPreferences.listOrGrid === 'table' && this.state.value === true) {
            // cannot show thumbnails for: table layout 
            this.handleChange(null, false)
        }

        return <>
            <Switch
                value={value}
                onChange={this.handleChange}
                animate={false}
                onText="On"
                offText="Off"
                disabled={this.props.preferenceName === 'images' && this.props.otherPreferences.listOrGrid === 'table'}
            />
            {this.props.preferenceName === 'images' && this.props.otherPreferences.listOrGrid === 'table' ? <span>Table layout does not show thumbnails</span> : null}
        </>
    }
}

Checkbox.propTypes = {};

export default Checkbox;
